import { render, staticRenderFns } from "./CollectionEditor.vue?vue&type=template&id=71724875"
import script from "./CollectionEditor.vue?vue&type=script&lang=ts"
export * from "./CollectionEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports